// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { KitTag } from './kit-tag';
import { ProgramKit } from './program-kit';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProgramKitTagMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK programKit */
  programKitId!: string;
  /** Guid key FK kitTag */
  kitTagId!: string;
  /** FK kitTagId */
  kitTag!: KitTag;
  /** FK programKitId */
  programKit!: ProgramKit;
}

